import { useEffect } from "react";
import { CollectionSlider } from "../components/home/collection-slider/CollectionSlider";
import { generalSettings, type DME, type DMEData } from "dmeditor";
import { fetchImages } from "../components/fetchImage";

export interface TrackEntity {
  schools?: string;
  list: Array<any>;
}

export const FavouriteDefinition: DME.Widget = {
  type: "frontpage-favourite",
  icon: "matchfit",
  name: "Top favourite",
  category: "basic",
  settings: [
    {
      name: "Schools",
      settingComponent: "input",
      property: ".schools",
      description: "School id, separate by ,",
    },
    ...generalSettings,
  ],
  events: {
    updateData: () => {},
    createBlock: (): DMEData.CreatedBlock<TrackEntity> => {
      return {
        type: "frontpage-favourite",
        data: {
          schools: "6,9,10",
          list: [],
        },
      };
    },
  },
};

const defaultList = [
  {
    name: "DEMO",
    city: "Test",
    image: {
      image: "https://images.unsplash.com/photo-1562774053-701939374585",
    },
  },
  {
    name: "DEMO",
    city: "Test",
    image: {
      image: "https://images.unsplash.com/photo-1562774053-701939374585",
    },
  },
];

export const Favourite = (props: DME.WidgetRenderProps<TrackEntity>) => {
  const {
    blockNode: { data },
  } = props;
  const { list = defaultList } = data;

  return (
    <div style={{ marginTop: 30 }}>
      <CollectionSlider list={list} />
    </div>
  );
};
